export let expandNavigationPaneButton = "_oiaY";
export default {expandNavigationPaneButton};